import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CompanyRespiratorInsertAccessories } from "src/app/models/company-respirator-insert-accessories.model";
import { ApiService } from "../api.service";
import { BaseService } from "./base.service";

@Injectable({
    providedIn: 'root'
  })

  export class CompanyRespiratorInsertAccessoriesService extends BaseService {

    constructor (
      protected apiService: ApiService,
      protected http: HttpClient
    ) {
      super(apiService, http, 'employees/[employee-id]/company-respirator-insert-accessories');
    }

    getAccessories() {
      return this.http.get<CompanyRespiratorInsertAccessories[]>(`${this.apiUrl}`);
    }

}
